'use strict';

var pdpQtyHelpers = require('./pdpQtyHelpers');
var toastMessageHelper = require('../utils/toastMessageHelper');
const pidRegex = /\//g;
var cartAddedTitle = $('.cartaddedtitle').val();
var cartaddmessage = $('.cartaddmessage').val();
var cartRemovedTitle = $('.cartremovedtitle').val();
var cartremovedmessage = $('.cartremovedmessage').val();
var cartrevtitle = $('.cartrevtitle').val();

$(document).ready(function () {
    var $styleminus = $('.ckc-quantity-selector').find('.ckc-qty-minus');
    var $changeicon = $('#minus-id');
    var val = $('.c-qty-input').val();
    if (val > $('.c-qty-input').attr('data-qty-min')) {
        $styleminus.addClass('minusbutton');
        $styleminus.removeClass('disablestate');
        $changeicon.attr('xlink:href', '#minus-symbol-incre');
    }
    var inputVal = parseInt($('.c-qty-input').val(), 10);
    var productAts = parseInt($('.productATSValue').val(), 10);
    if (inputVal === productAts) {
        $('.ckc-qty-plus').not($('.bulk-order-details .ckc-qty-plus')).addClass('max-disabled disablestate').prop('disabled', true);
        const warnMsg = $('#warning-msg').val();
        $('.ckc-max-limit-message').removeClass('d-none').text(warnMsg);
    }
    var minQty = parseInt($('.bulk-order-details .productMinOrderQty').val(), 10);
    $('.bulk-order-details .c-qty-input').val(minQty);
});

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

$(document).ready(function () {
    var $styleminus = $('.ckc-quantity-selector').find('.ckc-qty-minus');
    var val = parseInt($('.c-qty-input').val(), 10);
    if (val === 1) {
        $styleminus.addClass('disablestate');
        $styleminus.prop('disabled', true);
    } else {
        $styleminus.removeClass('disablestate');
        $styleminus.prop('disabled', false);
    }
});

$(document).ready(function () {
    const $input = $('.c-qty-input');
    const minquantity = parseInt($input.attr('data-qty-min'), 10);
    const maxquantity = parseInt($('.productMaxOrderQty').val(), 10);

    if (maxquantity === minquantity) {
        $('.ckc-max-limit-message').addClass('d-none').text('');
    }
});

/**
 * Gets the Available To Sell (ATS) value from the hidden input.
 * @returns {number} ATS value
 */
function getATSValue() {
    var ats = $('.productATSValue').val();
    return parseInt(ats, 10) || 0;
}

/**
 * Retrieves the maximum order quantity for a product based on the clicked button context.
 * @param {jQuery} $clickedBtn - The jQuery object representing the clicked button element.
 * @returns {number} The maximum order quantity. Returns 0 if not found or invalid.
 */
function getMaxOrderQty($clickedBtn) {
    var $bulkOrderModal = $clickedBtn.closest('.product-details-right, .bulk-order-details');
    var maxQty = $bulkOrderModal.find('.productMaxOrderQty').val();
    return parseInt(maxQty, 10) || 0;
}

/**
 * Updates the state of the minus and plus buttons based on the current quantity value.
 * @param {jQuery} $input - The quantity input element
 * @param {jQuery} $minus - The minus button element
 * @param {jQuery} $plus - The plus button element
 */
function updateButtons($input, $minus) {
    var val = parseInt($input.val(), 10) || 1;
    if (val <= 1) {
        $minus.attr('disabled', true);
    } else {
        $minus.attr('disabled', false);
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

$('body').on('click', '.price-and-pricebreakup .mini-click, .bulk-order-details .mini-click', function () {
    var pid = $(this).attr('data-pid');
    var removeUrl = $(this).attr('data-removeproduct');
    var encodedPID = pid ? pid.replace(pidRegex, '\\/') : '';
    var $input = $(this).parents('.c-qty-section').find('[data-quantity-count="quantity-count-' + encodedPID + '"]');
    var $limitMsg = $input.closest('.ckc-quantity-selector').find('.ckc-qty-plus');
    var $styleminus = $input.closest('.ckc-quantity-selector').find('.ckc-qty-minus');
    var $inputVal = $(this).parents('.c-qty-section').find('.c-qty-input');
    var $changeicon = $input.closest('.ckc-quantity-selector').find('#minus-id');
    var $minus = $(this);
    var count = Number($input.val(), 10) - 1;
    var minVal = Number($(this).attr('data-qty-min'));
    var maxQty = getMaxOrderQty($(this));
    var currentSelectedValue = parseInt($input.val(), 10);
    if (count < maxQty) {
        $limitMsg.removeClass('max-disabled disablestate');
        $limitMsg.prop('disabled', false);
        $('.product-details-right .ckc-max-limit-message').addClass('d-none').text('');
    }
    if (count <= minVal) {
        $styleminus.removeClass('minusbutton');
        $changeicon.attr('xlink:href', '#minus-symbol-decre');
        $styleminus.addClass('disablestate');
    }
    if (!minVal || currentSelectedValue <= minVal) {
        $(this).attr('data-min-qty-reached', true);
        var deleteBtn = $(this).closest('.button-for-updates').find('.remove-product');
        if (deleteBtn) {
            deleteBtn.trigger('click');
        }
    } else {
        $input.val(count);
    }
    updateButtons($inputVal, $minus);
    if ($('.hide-cart-btn').length > 0) {
        if ($(this).closest('.price-and-pricebreakup').length > 0) {
            $('.price-and-pricebreakup .c-qty-input').trigger('change', {
                presentContext: $(this), cartTitle: cartRemovedTitle, cartMessage: cartremovedmessage, removeUrl: removeUrl
            });
        } else if ($(this).closest('.bulk-order-details').length > 0) {
            $('.bulk-order-details .c-qty-input').trigger('change', {
                presentContext: $(this), cartTitle: cartRemovedTitle, cartMessage: cartremovedmessage, removeUrl: removeUrl
            });
        } else {
            $('.c-qty-input').trigger('change', {
                presentContext: $(this), cartTitle: cartRemovedTitle, cartMessage: cartremovedmessage, removeUrl: removeUrl
            });
        }
    }
});

$('body').on('click', '.price-and-pricebreakup .max-click, .bulk-order-details .max-click', function () {
    var $inputVal = $(this).siblings('.c-qty-input');
    var pid = $(this).attr('data-pid');
    var encodedPID = pid ? pid.replace(pidRegex, '\\/') : '';
    var $input = $(this).parents('.c-qty-section').find('[data-quantity-count="quantity-count-' + encodedPID + '"]');
    var $limitMsg = $input.closest('.ckc-quantity-selector').find('.ckc-qty-plus');
    var $styleminus = $input.closest('.ckc-quantity-selector').find('.ckc-qty-minus');
    var $changeicon = $input.closest('.ckc-quantity-selector').find('#minus-id');
    var $maxlimit = $input.closest('.product-details').find('.ckc-qty-limit-message');
    var $minus = $(this).siblings('.ckc-qty-minus');
    var ats = getATSValue();
    const warnMsg = $('#warning-msg').val();
    var maxQty = getMaxOrderQty($(this));
    var maxLimit = 0;
    var isBulkOrder = $(this).closest('.bulk-order-details').length > 0;
    if (isBulkOrder) {
        maxLimit = maxQty;
    } else if (ats > 0 && maxQty > 0) {
        maxLimit = Math.min(ats, maxQty);
    } else if (ats > 0) {
        maxLimit = ats;
    } else if (maxQty > 0) {
        maxLimit = maxQty;
    }
    var count = (Number($input.val(), 10)) + 1;
    if (count >= 2) {
        $styleminus.addClass('minusbutton');
        $changeicon.attr('xlink:href', '#minus-symbol-incre');
        $styleminus.removeClass('disablestate');
    }
    if (count >= maxLimit) {
        $limitMsg.addClass('max-disabled disablestate');
        $maxlimit.removeClass('d-none');
        $limitMsg.prop('disabled', true);
    }
    $input.val(count);
    updateButtons($inputVal, $minus);
    if ($('.hide-cart-btn').length > 0) {
        if ($(this).closest('.price-and-pricebreakup').length > 0) {
            $('.price-and-pricebreakup .c-qty-input').trigger('change', { presentContext: $(this), cartTitle: cartAddedTitle, cartMessage: cartaddmessage });
        } else if ($(this).closest('.bulk-order-details').length > 0) {
            $('.bulk-order-details .c-qty-input').trigger('change', { presentContext: $(this), cartTitle: cartAddedTitle, cartMessage: cartaddmessage });
        } else {
            $('.c-qty-input').trigger('change', { presentContext: $(this), cartTitle: cartAddedTitle, cartMessage: cartaddmessage });
        }
    }
    if (maxLimit > 0 && count >= maxLimit) {
        if ($(this).closest('.bulk-order-details').length) {
            return;
        }
        $('.product-details-right .ckc-max-limit-message').removeClass('d-none').text(warnMsg);
    }
});

$('body').on('focusin', '.c-qty-input', function () {
    $(this).attr('data-old-value', $(this).val());
});

$('body').on('change keyup blur', '.c-qty-input', function (event, data) {
    var $input = $(this);
    var val = parseInt($input.val(), 10) || 1;
    var ats = getATSValue();
    var maxQty = getMaxOrderQty($(this));
    var $styleminus = $input.closest('.ckc-quantity-selector').find('.ckc-qty-minus');
    var $limitMsg = $input.closest('.ckc-quantity-selector').find('.ckc-qty-plus');
    var $changeicon = $input.closest('.ckc-quantity-selector').find('#minus-id');
    const limitMsg = $('#limit-msg').val();
    const warnMsg = $('#warning-msg').val();
    var maxLimit = 0;
    var isBulkOrder = $(this).closest('.bulk-order-details').length > 0;
    if (isBulkOrder) {
        maxLimit = maxQty;
    } else if (ats > 0 && maxQty > 0) {
        maxLimit = Math.min(ats, maxQty);
    } else if (ats > 0) {
        maxLimit = ats;
    } else if (maxQty > 0) {
        maxLimit = maxQty;
    }

    if (maxLimit === 1) {
        $styleminus.removeClass('minusbutton');
        $changeicon.attr('xlink:href', '#minus-symbol-decre');
        $styleminus.addClass('disablestate');
    } else if (val > 1) {
        $styleminus.addClass('minusbutton');
        $styleminus.removeClass('disablestate');
        $changeicon.attr('xlink:href', '#minus-symbol-incre');
    } else {
        $styleminus.removeClass('minusbutton');
        $changeicon.attr('xlink:href', '#minus-symbol-decre');
        $styleminus.addClass('disablestate');
    }
    if (val === maxQty || val >= maxLimit) {
        $limitMsg.addClass('max-disabled disablestate');
        $limitMsg.prop('disabled', true);
    } else {
        $limitMsg.removeClass('max-disabled disablestate');
        $limitMsg.prop('disabled', false);
    }
    updateButtons($input, $input.siblings('.ckc-qty-minus'));
    if (maxLimit > 0 && val > maxLimit) {
        $input.val(maxLimit);
        if ($(this).closest('.bulk-order-details').length) {
            return;
        }
        $('.product-details-right .ckc-max-limit-message').removeClass('d-none').text(limitMsg);
    } else if ((maxLimit > 0 && val === maxLimit) && $('.ckc-max-limit-message').text() === '') {
        if ($(this).closest('.bulk-order-details').length) {
            return;
        }
        $('.product-details-right .ckc-max-limit-message').removeClass('d-none').text(warnMsg);
    } else {
        if ($(this).closest('.bulk-order-details').length) {
            return;
        }
        $('.product-details-right .ckc-max-limit-message').addClass('d-none').text('');
    }
    var qtyValidation = pdpQtyHelpers.validateQuantity($(this), false);
    if ((qtyValidation.isValidQuantity) && ($('.hide-cart-btn').length > 0)) {
        var cartTitle = data && data.cartTitle ? data.cartTitle : cartAddedTitle;
        $('body').trigger('updateCartQty', {
            context: $(this),
            inputUpdate: true,
            cartTitle: cartTitle,
            presentContext: data ? data.presentContext : '',
            removeUrl: data ? data.removeUrl : '',
            cartMessage: data ? data.cartMessage : ''
        });
    }
});

$('body').on('keypress', '.c-qty-input', function (event) {
    if (event.keyCode === 69 || event.keyCode === 101 || event.key === '+') {
        event.preventDefault();
        $(this).val(1);
    }
    if ($(this).val() === '' && (event.charCode < 49 || event.charCode > 57)) {
        event.preventDefault();
        $(this).val(1);
    }
});

$('body').on('focusout', '.c-qty-input', function () {
    var $this = $(this);
    if ($this.val() === '' || $this.val() === '0' || $this.val() === '00') {
        $this.val('1');
    }
});

$(document).on('click', function (e) {
    if (!$(e.target).closest('.quantity').length) {
        const $target = $('.ckc-max-limit-message');
        if (!$target.hasClass('d-none')) {
            $target.addClass('d-none').text('');
        }
    }
});

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    $('.minicart-quantity').removeClass('d-none');
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    }
}

$('body').on('updateCartQty', function (e, eventData) {
    var context = eventData.context;
    var presentContext = eventData.presentContext;
    $(this).hasClass('add-to-cart-global');
    var productID = context.attr('data-pid');
    var encodedPID = productID ? productID.replace(pidRegex, '\\/') : '';
    var quantity = context.parents('.c-qty-section').find('[data-quantity-count="quantity-count-' + encodedPID + '"]').val();
    var url = context.attr('data-action');
    var removeProductUurl = eventData.removeUrl;
    var uuid = context.attr('data-uuid');

    var urlParams = {
        pid: productID,
        quantity: quantity,
        uuid: uuid
    };
    url = appendToUrl(url, urlParams);
    if (!url) {
        $.spinner().stop();
        return;
    }

    $('body').trigger('product:beforeAddToCart', this);
    if (presentContext.hasClass('add-to-bag-increment') && $('.coinProduct').val() === 'true') {
        $('button.add-to-bag').addClass('from-incre');
        $('button.add-to-bag').trigger('click');
    } else if (presentContext.hasClass('remove-from-bag-decrement') && $('.coinProduct').val() === 'true') {
        var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
        $deleteConfirmBtn.data('pid', productID);
        $deleteConfirmBtn.data('action', removeProductUurl);
        $deleteConfirmBtn.data('uuid', uuid);
        $('.cart-delete-confirmation-btn').trigger('click');
        toastMessageHelper.showNotification(cartrevtitle, cartremovedmessage, 'Basket-icon');
    } else {
        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                handlePostCartAdd(data);
                toastMessageHelper.productAddRemoveNotification(eventData.cartTitle, eventData.cartMessage);
                $('body').trigger('product:afterAddToCart', data);
                $.spinner().stop();
                miniCartReportingUrl(data.reportingURL);
                pdpQtyHelpers.updateQtyBtn(context, Number(quantity));
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
});
